import { collection, doc, getDoc, setDoc, Timestamp } from 'firebase/firestore';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { firestore } from 'services';
import { Button, Input, SelectForm } from 'shared/Components';
import { FlexContainer, Text } from 'shared/Typhography';
import styled from 'styled-components';

interface CreateRequestModalProps {
  close: (refreshDoc: boolean) => void;
  user: { id: string; name: string; profileImage: string };
  artists: { label: string; value: string }[];
}

const ModalContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-sizing: border-box;
  min-width: 300px;
  min-height: 500px;
  display: flex;
  flex-flow: column;
  gap: 20px;
`;

interface FormInputs {
  userId?: any;
  requestedAmount?: number;
}

export default function CreateRequestModal({ close, user, artists }: CreateRequestModalProps) {
  const { handleSubmit, control } = useForm<FormInputs>();

  const onSubmit = handleSubmit(async (data: FormInputs) => {
    data.userId = data?.userId?.value;

    if (!data?.requestedAmount || !data?.userId) {
      toast.error('You have to fill all fields!');
      return;
    }

    try {
      const artistDoc = doc(firestore, `usersWeb/${data?.userId}`);
      const artist = await getDoc(artistDoc);

      const collectionRef = collection(firestore, 'payoutRequests');

      await setDoc(doc(collectionRef), {
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now(),
        status: 'requested',
        requestedAmount: +data.requestedAmount,
        requestedBy: {
          id: user?.id,
          name: user?.name,
          profileImage: user?.profileImage,
        },
        approvedAmount: null,
        paymentMethod: null,
        artist: {
          id: artist.id,
          name: artist.data()?.name ?? artist.data()?.Name ?? '-',
          profileImage: artist.data()?.profileImageUrl ?? '-',
        },
      });

      toast.success('Payout request created.');
      close(true);
    } catch (err) {
      toast.error('Something went wrong!');
      console.log(err);
    }
  });

  return (
    <ModalContainer>
      <Text weight="bold">Create Payout Request</Text>

      <form
        style={{
          marginTop: '50px',
          flex: '1',
          display: 'flex',
          justifyContent: 'space-between',
          flexFlow: 'column',
        }}
        onSubmit={onSubmit}
        onKeyPress={(event) => {
          if (event.key == 'Enter') event.preventDefault();
        }}
      >
        <Input
          required
          label="Requested Amount"
          placeholder="Enter requested amount"
          name="requestedAmount"
          type="number"
          control={control}
          width="100%"
          marginBottom={20}
          marginRight={30}
          margin="0 auto 40px"
        />
        <SelectForm
          required
          label="Artist"
          placeholder="Select Artist"
          name="userId"
          control={control}
          values={artists}
          width="100%"
          margin="0 auto 40px"
        />
        <FlexContainer justifyContent="flex-end" gap="20px" margin="auto 0 0 0">
          <Button
            style={{ padding: '5px' }}
            width="max-content"
            variant="danger"
            onClick={() => close(false)}
          >
            Close
          </Button>
          <Button style={{ padding: '5px' }} width="max-content" type="submit">
            Submit
          </Button>
        </FlexContainer>
      </form>
    </ModalContainer>
  );
}
